// extracted by mini-css-extract-plugin
module.exports = {"inputSliderWrapper":"DurationFilter-module__inputSliderWrapper___C+Puh"};